<template>
  <v-skeleton-loader
    class="mx-auto"
    max-height="200px"
    max-width="200px"
    type="image"
  >
    <v-img
      v-if="imageLoaded"
      :src="imageURL"
      @error="onImgError"
      @load="onImgLoad"
      cover
      style="margin: 0 auto"
      width="300px"
    >
      <template v-slot:placeholder>
        <v-skeleton-loader
          class="mx-auto"
          max-width="200"
          type="image"
        ></v-skeleton-loader>
      </template>
    </v-img>
    <!-- <v-skeleton-loader v-else boilerplate type="image"></v-skeleton-loader> -->
    <v-img v-else :src="noImage"></v-img>
  </v-skeleton-loader>
</template>

<script>
export default {
  props: {
    product: {},
  },
  data() {
    return {
      imageLoaded: true,
      noImage: require("@/assets/product/awaiting_image.png"),
    };
  },
  computed: {
    imageURL() {
      console.log("-- IMAGE AXIOS");
      console.log(this.$axios.defaults);
      return this.$axios.defaults.prodImagesURL + this.product.prod_no + ".png";
    },
  },

  methods: {
    onImgError() {
      this.imageLoaded = false;
      return false;
    },
    onImgLoad() {
      console.log("-- Image Load Success");
      this.imageLoaded = true;
      return;
    },
  },
};
</script>

<style lang="sass" scoped>
</style>